import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2'; 
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from 'primereact/api';
import { createUser, deleteUser, fetchUser, updateUser } from '../slice/userSlice';
import Main from '../App';
import Modal from './components/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRole, fetchCabang } from '../slice/roleSlice';
import { InputSearch } from './components/TextField'
import { Skeleton } from 'primereact/skeleton';
    
function UserPage(){
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const openAddModal = () => {
        setName('');
        setEmail('');
        setPassword('');
        setRole('');
        setCabang('');
        setSelectedData(''); 
        setIsAddModalOpen(true)
    };
    const openEditModal = (data) => {
        setName(data.name);
        setEmail(data.email);
        setPassword(data.password);
        setRole(data.roles[0]?.name || '');
        setCabang(data.kodegrupcabang || ''); // aman kalau cabang kosong/undefined
        setSelectedData(data); 
        setIsEditModalOpen(true);
    };
    const closeAddModal = () => setIsAddModalOpen(false);
    const closeEditModal = () => setIsEditModalOpen(false);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [isButtonClick, setIsButtonClick] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('');
    const [cabang, setCabang] = useState('');
    const [selectedData, setSelectedData] = useState(null);
    const dispatch = useDispatch();
    const {users, isLoading, error } = useSelector((state) => state.users);
    const { roles = [] } = useSelector((state) => state.roles || {});    
    const { cabangs = [] } = useSelector((state) => state.roles || {});    
  
    //console.log("Cabangs list:", cabangs);

    const handleStore = (e) => {
        e.preventDefault();
        setIsButtonClick(true);
        const credentialsCreate = { name: name, email: email , password: password, role: role, kodegrupcabang: cabang, grup: role };

        dispatch(createUser(credentialsCreate))
        .unwrap() 
        .then((response) => {
            if(response.success){
                setName('');
                setEmail('');
                setPassword('');
                setRole('');
            }
            setIsAddModalOpen(false);
            setIsButtonClick(false);
            Swal.fire("Success", response.message, "success");
        })
        .catch((err) => {
            setIsAddModalOpen(false);
            setIsButtonClick(false);
            Swal.fire("Failed", err, "error");
        });
    }

    const handleUpdate = async (e) => {
        e.preventDefault();
        setIsButtonClick(true);        
        const credentialsUpdate = { id : selectedData.id, name: name, email: email, password: password, role: role, kodegrupcabang: cabang, grup: role };
        dispatch(updateUser(credentialsUpdate))
        .unwrap() 
        .then((response) => {            
            if(response.success){
                setName('');
                setEmail('');
                setPassword('');
                setRole('');
            }
            setIsEditModalOpen(false);
            setIsButtonClick(false);
            Swal.fire("Success", response.message, "success");
        })
        .catch((err) => {
            setIsEditModalOpen(false);
            setIsButtonClick(false);
            Swal.fire("Failed", err, "error");
        });
    }

    const handleDelete = async (id) => {
        const confirmed = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this data? This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            preConfirm: () => {
                return dispatch(deleteUser(id))
                .unwrap() 
                .then((response) => {
                    Swal.fire("Success", response.message, "success");
                })
                .catch((err) => {
                    Swal.showValidationMessage(`Request failed: ${err.message || err}`);
                });
            },
        });
    
        if (!confirmed.isConfirmed) {
            return;
        }
    };
    
    // Prime Datatable
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        
        const _filters = {
            ...filters,
            global: { ...(filters?.global || {}), value },
        };
    
        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue("");
    };

    useEffect(() => {
        initFilters();
        dispatch(fetchUser()).unwrap();        
        dispatch(fetchRole()).unwrap();
        dispatch(fetchCabang()).unwrap();
    }, [dispatch]); 

    const renderHeader = () => {
        return (
            <div className="row my-3">
                <div className='col-md-4'>
                    {users.length <= 0 ? (
                        <Skeleton width='100%' height='3rem' borderRadius='10px'/>
                    ):(
                        <InputSearch iconLeft="bi bi-search" name="searchInput" type="text" placeholder="Search" style={{ borderColor: "#ccc" }} value={globalFilterValue} onChange={onGlobalFilterChange} />
                    )}
                </div>
            </div>
        );
    };

    const header = renderHeader();

    return (
        <Main>
            <div className='row my-3'>
                <div className='col-md-6'>
                    <h5 className='fw-semibold'>User</h5>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User</li>
                        </ol>
                    </nav>
                </div>
                <div className='col-md-5 d-flex justify-content-end'>
                    <div>
                        {users.length <= 0 ? (
                            <Skeleton width='100px' height='2.5rem' borderRadius='10px'/>
                        ):(
                            <button className="btn btn-dark" onClick={openAddModal}>
                                Add New
                            </button>
                        )}
                        <Modal isOpen={isAddModalOpen} onClose={closeAddModal} title={'Add User'} modalId={'addUserModal'}>
                            <form onSubmit={handleStore}>
                                <div className="row my-3">
                                    <div className="col-md-6">
                                        <label>Name</label>
                                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" placeholder='Enter Name'/>
                                    </div>
                                    <div className="col-md-6">
                                        <label>Email</label>
                                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder='Enter Email'/>
                                    </div>
                                </div>
                                <div className="row my-3">
                                    <div className="col-md-6">
                                        <label>Role</label>
                                        <select value={role} onChange={(e) => setRole(e.target.value)} className="form-control">
                                            <option value="">-- Select Role --</option>
                                            {roles.map((roleData, index) => (
                                                <option key={index} value={roleData.name}>
                                                    {roleData.name}
                                                </option>
                                            ))}
                                        </select>                                                
                                    </div>
                                    <div className="col-md-6">
                                        <label>password</label>
                                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" placeholder='Enter Password'/>
                                    </div>
                                </div>
                                <div className="row my-3">
                                    <div className="col-md-6">
                                        <label>Cabang</label>
                                        <select
                                        value={cabang}
                                        onChange={(e) => setCabang(e.target.value)}
                                        className="form-control"
                                        >
                                        <option value="">-- Select Cabang --</option>
                                            {cabangs.map((cabangData, index) => (
                                            <option key={index} value={cabangData.kode}>
                                                {cabangData.cabang}
                                            </option>
                                            ))}
                                    </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-dark" disabled={isButtonClick}>{isButtonClick ? 'Saving...' : 'Confirm'}</button>
                                    </div>
                                </div>
                            </form>
                        </Modal>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-11'>
                    <div className='card'>
                        <div className='card-body'>
                            {header}
                            <div className='row'>
                                <div className='col-md-12'>
                                    {users.length <= 0 ? (
                                        <Skeleton width='100%' height='20rem' borderRadius='10px'/>
                                    ):(
                                        <DataTable value={users} paginator showGridlines rows={10} dataKey="id" filters={filters} globalFilterFields={['name', 'email']} emptyMessage="No users found." onFilter={(e) => setFilters(e.filters)}>
                                            <Column header="No"  body={(rowData, { rowIndex }) => (isLoading ? <Skeleton/> : (rowIndex + 1))} />
                                            <Column field="name" header="Name" body={(rowData) => (isLoading ? <Skeleton/> : (rowData.name ?? '-'))}/>
                                            <Column field="email" header="Email" body={(rowData) => (isLoading ? <Skeleton/> : (rowData.email ?? '-'))}/>
                                            <Column header="Role" body={(rowData) => (isLoading ? <Skeleton/> : ((rowData.roles ?? [])[0]?.name || "-"))} />
                                            <Column field="Cabang" header="Cabang" body={(rowData) => (isLoading ? <Skeleton/> : (rowData.kodegrupcabang ?? '-'))}/>
                                            <Column header="Action" body={(rowData) => (isLoading ? <Skeleton/> : (
                                                <div className="d-flex gap-2">
                                                    <button className="btn btn-sm btn-outline-success" onClick={() => openEditModal(rowData)}>
                                                        <i className="bi bi-pencil"></i>
                                                    </button>
                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(rowData.id)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                                ))} />
                                        </DataTable>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={isEditModalOpen} onClose={closeEditModal} title={'Edit User'} modalId={'editUserModal'}>
                <form onSubmit={handleUpdate}>
                    <div className="row my-3">
                        <div className="col-md-6">
                            <label>Name</label>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" placeholder='Enter Name'/>
                        </div>
                        <div className="col-md-6">
                            <label>Email</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" placeholder='Enter Email'/>
                        </div>
                    </div>
                    <div className="row my-3">
                        <div className="col-md-6">
                            <label>Role</label>
                            <select value={role} onChange={(e) => setRole(e.target.value)} className="form-control">
                                <option value="">-- Select Role --</option>
                                {roles.map((roleData, index) => (
                                    <option key={index} value={roleData.name}>
                                        {roleData.name}
                                    </option>
                                ))}
                            </select>                                                
                        </div>
                        <div className="col-md-6">
                            <label>password</label>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" placeholder='Enter Password'/>
                        </div>
                    </div>
                    <div className="row my-3">
                        <div className="col-md-6">
                            <label>Cabang</label>
                            <select
                                value={cabang}
                                onChange={(e) => setCabang(e.target.value)}
                                className="form-control"
                                >
                                <option value="">-- Select Cabang --</option>
                                    {cabangs.map((cabangData, index) => (
                                    <option key={index} value={cabangData.kode}>
                                        {cabangData.cabang}
                                    </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-end">
                            <button type="submit" className="btn btn-dark" disabled={isButtonClick}>{isButtonClick ? 'Saving...' : 'Confirm'}</button>
                        </div>
                    </div>
                </form>
            </Modal>

        </Main>
    );
}

export default UserPage;